<script>
	import moment from 'moment'
	import Steps from '../Steps';
	import swal from 'sweetalert';
	import DatePicker from 'vue2-datepicker';
	import { mapState,mapMutations } from 'vuex';
	import TipoLocacion from '../modals/TipoLocacion.vue';
	import ProveedorNumSap from '../modals/ProveedorNumSap.vue';
	import PagadorSap from '../modals/PagadorSap.vue';
	import {stepTwoTarget} from '../../stepsTargets.js';


	export default{
		props:{
			reviewApprove: {
				type: Boolean,
				default: false
			}
		},
		components:{Steps,TipoLocacion,ProveedorNumSap,DatePicker,PagadorSap},
		data(){
			return {
				startTour:false,
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Terminar paso'
					}
				},
			}
		},
		computed:{
			...mapState(['stepActive','stepTwo','alertas','ejercicioActivo','tiendaSeleccionada']),
			steps(){
				return stepTwoTarget(this.tiendaSeleccionada);
			},
			validoDesdeFecha(){
				return this.stepTwo.validoDesdeFecha;
			},
			validoHastaFecha(){
				return this.stepTwo.validoHastaFecha;
			},
			tipoDeLocacion(){
				return this.stepTwo.tipoDeLocacion;
			}
		},
		watch:{
			startTour(){
				if(this.startTour && this.stepActive == 2 && this.alertas){
					this.$tours['stepTwo'].start();
				}
			},
			validoDesdeFecha(){
				if(this.ejercicioActivo == 'ejercicio-1'){
					if(this.stepTwo.validoDesdeFecha != '' && moment(this.stepTwo.validoDesdeFecha).format("YYYY-MM-DD") != '2019-07-01'){
						swal({title: "¡Atención!",text: 'La fecha debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.validoDesdeFecha = '');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-2'){
					if(this.stepTwo.validoDesdeFecha != '' && moment(this.stepTwo.validoDesdeFecha).format("YYYY-MM-DD") != '2019-07-15'){
						swal({title: "¡Atención!",text: 'La fecha debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.validoDesdeFecha = '');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-3'){
					if(this.stepTwo.validoDesdeFecha != '' && moment(this.stepTwo.validoDesdeFecha).format("YYYY-MM-DD") != '2019-07-01'){
						swal({title: "¡Atención!",text: 'La fecha debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.validoDesdeFecha = '');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-4'){
					if(this.stepTwo.validoDesdeFecha != '' && moment(this.stepTwo.validoDesdeFecha).format("YYYY-MM-DD") != '2019-07-15'){
						swal({title: "¡Atención!",text: 'La fecha debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.validoDesdeFecha = '');
					}
				}
			},
			validoHastaFecha(){
				if(this.ejercicioActivo == 'ejercicio-1'){
					if(this.stepTwo.validoHastaFecha != '' && moment(this.stepTwo.validoHastaFecha).format("YYYY-MM-DD") != '2019-12-31'){
						swal({title: "¡Atención!",text: 'La fecha debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.validoHastaFecha = '');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-2'){
					if(this.stepTwo.validoHastaFecha != '' && moment(this.stepTwo.validoHastaFecha).format("YYYY-MM-DD") != '2019-09-15'){
						swal({title: "¡Atención!",text: 'La fecha debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.validoHastaFecha = '');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-3'){
					if(this.stepTwo.validoHastaFecha != '' && moment(this.stepTwo.validoHastaFecha).format("YYYY-MM-DD") != '2019-12-31'){
						swal({title: "¡Atención!",text: 'La fecha debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.validoHastaFecha = '');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-4'){
					if(this.stepTwo.validoHastaFecha != '' && moment(this.stepTwo.validoHastaFecha).format("YYYY-MM-DD") != '2019-09-15'){
						swal({title: "¡Atención!",text: 'La fecha debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.validoHastaFecha = '');
					}
				}
			},
			tipoDeLocacion(){
				if(this.ejercicioActivo == 'ejercicio-1' || this.ejercicioActivo == 'ejercicio-2'){
					if(this.stepTwo.tipoDeLocacion != '' && this.stepTwo.tipoDeLocacion != '100001'){
						swal({title: "¡Atención!",text: 'El tipo de locación debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.tipoDeLocacion = '');
					}
				}
				if(this.ejercicioActivo == 'ejercicio-3' || this.ejercicioActivo == 'ejercicio-4'){
					if(this.stepTwo.tipoDeLocacion != '' && this.stepTwo.tipoDeLocacion != '100017'){
						swal({title: "¡Atención!",text: 'El tipo de locación debe corresponder con el ejercicio.',icon: "error",button: 'Aceptar'})
						.then(() => this.stepTwo.tipoDeLocacion = '');
					}
				}
			}
		},
		mounted(){
			window.$('#crear-solicitud-acuerdo').on('show.bs.modal', () => {
				setTimeout(() => window.$('.modal-backdrop+.modal-backdrop').css('z-index',1050),1);
			});
		},
		methods:{
			...mapMutations(['changeStepActive','saveStepTwo']),
			
			saveStep(stepC){

				if(this.ejercicioActivo != 'evaluacion-1' && this.ejercicioActivo != 'evaluacion-2'){
					if(this.stepTwo.validoDesdeFecha != '' &&
						this.stepTwo.validoHastaFecha != '' &&
						this.stepTwo.tipoDeLocacion != '' &&
						this.stepTwo.numeroSAP != '' &&
						this.stepTwo.pagadorSAP != '' &&
						this.stepTwo.pagadorSAP != "Cambia este pagador"){

						this.changeStepActive(this.stepActive+1);
						this.saveStepTwo(this.stepTwo);
		
					}else{
						swal({title: "¡Atención!",text: 'Antes de continuar debes llenar toda la información del ejercicio.',icon: "error",button: 'Aceptar'});
					}

				}else{

					this.changeStepActive(stepC);
					this.saveStepTwo(this.stepTwo);

				}

			},
			showModalLoacion(){
				window.$('#tipo-locacion').modal('show');
			},
			restartTour(){
				this.$tours['stepTwo'].start();
			},
			cambiarPagador(){
				window.$('#pagador-sap-986698').modal('show');
			},
			setPP(evt){
				let typeProvider = evt.length > 1;
				this.stepTwo.numeroSAP = typeProvider ? 'Multiples valores seleccionados':evt.acredor;
				this.stepTwo.pagadorSAP = 'Cambia este pagador';
			},
			setPP2(evt){
				this.stepTwo.pagadorSAP = evt.acredor;
			}
		}
	}
</script>
<template>
	<div class="contenido">
		<v-tour name="stepTwo" :steps="steps" :options="myOptions"/>
		<div v-if="!reviewApprove">
			<div class="header-tools">
				<div class="title">
					Crear Solicitud Acuerdo: Paso 2 (Información General)
				</div>
				<div class="buttons">
					<div>
						<button @click="saveStep(stepActive-1)"> <i class="fas fa-chevron-left"></i> Atrás </button>
						<button data-v-step="18" @click="saveStep(stepActive+1)">Continuar <i class="fas fa-chevron-right"></i></button>
						<span class="separator-buttons">|</span>
						<button> Guardar </button>
						<button> Cancelar </button>
						| <button v-if="alertas" @click="restartTour()" class="btn-icon"><i class="fas fa-question-circle"></i> Instrucciones</button>
					</div>
				</div>
			</div>
			<steps @startTwoTour="startTour = $event" :stepActive="stepActive"/>
			<hr class="separator-steps-content">
		</div>
		<div class="container">
			<div class="information-general">
				<div class="title">
					Información General
				</div>
				<div class="info-body">
					<div class="row">
						<div class="col-md-8">
							<div class="row mb-10">
								<div class="col-md-4">Nueva Solicitud Acuerdo</div>
								<div class="col-md-4">Tipo Sol. Acuerdo: Volumen</div>
								<div class="col-md-4">Solicitud Acuerdo:</div>
							</div>
							<div class="row mb-25">
								<div class="col-md-4">Estado: Borrador Solicitud Acuerdo</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-9 mt-10">
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label for="" class="control-label i">País</label>
							<select v-model="stepTwo.pais" class="form-control">
								<option value="México">México</option>
							</select>
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group">
							<label for="" class="control-label i">Organización Compras:</label>
							<input type="text" v-model="stepTwo.organizacionCompras" class="form-control" value="MX01-AUTOS Y SERVICIO" readonly="">
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group">
							<label for="" class="control-label i">Grupo Compras:</label>
							<input type="text" v-model="stepTwo.grupoCompras" class="form-control" value="M11-Org. Compras MX" readonly="">
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4">
						<div class="form-group" data-v-step="7">
							<label for="" class="control-label i">Descripción Solicitud Acuerdo:</label>
							<input type="text" v-model="stepTwo.descripcionSolicitudAcuerdo" class="form-control" value="Acuerdo de volumen">
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group" data-v-step="8">
							<label for="" class="control-label i">Válido desde fecha:</label>
							<date-picker type="date" v-model="stepTwo.validoDesdeFecha" lang="es" format="YYYY-MM-DD" confirm confirm-text="Aplicar" placeholder=""/>
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group" data-v-step="9">
							<label for="" class="control-label i">Válido hasta fecha:</label>
							<date-picker type="date" v-model="stepTwo.validoHastaFecha" lang="es" format="YYYY-MM-DD" confirm confirm-text="Aplicar" placeholder=""/>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4">
						<div class="form-group" data-v-step="10">
							<label for="" class="control-label i">Tipo de Locación:</label>
							<input @focus="showModalLoacion()" type="text" v-model="stepTwo.tipoDeLocacion" class="form-control paste" value="">
							<div>
								<!-- <a data-toggle="modal" data-target="#tipo-locacion" class="a-blue-link">Añadir adicional</a> -->
								<a class="a-blue-link">Añadir adicional</a>
							</div>
							
						</div>
						<tipo-locacion @setLocacion="stepTwo.tipoDeLocacion = $event"/>
					</div>
					<div class="col-md-4">
						
					</div>
					<div class="col-md-4">
						<div class="form-group mt-30" data-v-step="11">
							<div class="checkbox">
								<label>
									<input type="checkbox" v-model="stepTwo.autoRenovacion" name="typeRequest"> Auto renovación de acuerdo
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="subtitle-content">
					Términos/Liquidación
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="form-group" data-v-step="12">
							<label for="" class="control-label">Método de pago:</label>
							<select v-model="stepTwo.metodoDePago" class="form-control">
								<option value="Neteo">Neteo</option>
								<option value="No-Neteo">No-Neteo</option>
							</select>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group" data-v-step="13">
							<label for="" class="control-label i">Moneda:</label>
							<select v-model="stepTwo.moneda" class="form-control">
								<option value="Pesos mexicanos">Pesos mexicanos</option>
							</select>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="form-group" data-v-step="14">
							<label for="" class="control-label i">Calendario de Liquidación:</label>
							<select v-model="stepTwo.calendarioDeLiquidacion" class="form-control">
								<option value="MX AMS Calendario mensual de liquidación">MX AMS Calendario mensual de liquidación</option>
								<option value="MX AMS Calendario diario de liquidación">MX AMS Calendario diario de liquidación</option>
							</select>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group" data-v-step="15">
							<label for="" class="control-label">Términos de Pago:</label>
							<input v-model="stepTwo.terminosDePago" type="text" class="form-control"><small>Pago al contado</small>
						</div>
					</div>
				</div>
				<div class="subtitle-content">
					Proveedor
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="form-group" data-v-step="16">
							<label for="" class="control-label i">Número SAP de Proveedor:</label>
							<input type="text" v-model="stepTwo.numeroSAP" class="form-control paste" value="">
							<div>
								<a data-toggle="modal" data-target="#proveedor-num-sap" class="a-blue-link">Añadir adicional</a>
							</div>
						</div>
						<proveedor-num-sap @setPagador="setPP($event)"/>
						<pagador-sap @setPPP="setPP2($event)"/>
					</div>
					<div class="col-md-6">
						<div class="form-group" data-v-step="17">
							<label for="" class="control-label i">Pagador SAP:</label>
							<input @focus="cambiarPagador()" type="text" v-model="stepTwo.pagadorSAP" class="form-control paste" value="">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>